/**
 * `tally.*` wire contract (Increment 8b) — Tally voucher XML export.
 *
 * Generic finance: any business exports its invoices to Tally, so this is a
 * plain `tenantedProcedure` (not garment-gated). V1 is a one-way download of a
 * single invoice as a Sales-voucher XML; bi-directional sync is V2.
 */
import { z } from "zod";
import { uuid } from "../_common.js";

export const exportInvoiceInput = z.object({ invoiceId: uuid });

export const exportInvoiceOutput = z.object({
  /** Suggested download filename, e.g. `tally-INV-0007.xml`. */
  fileName: z.string(),
  /** The invoice doc number, or null for an unissued draft. */
  voucherNumber: z.string().nullable(),
  /** The Tally "Import Data" envelope XML. */
  xml: z.string(),
});

export type ExportInvoiceOutput = z.infer<typeof exportInvoiceOutput>;
